import { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { getQueryData } from "../service/common";

export default function ModuleEmbedLayout() {
  const route_location = useLocation();
  const [queryData, setQueryData] = useState({
    building: "", // 大樓
    floor: "", // 樓層
    room: "", // 房號
  });

  useEffect(() => {
    if (route_location.search) {
      let data = getQueryData({ str: route_location.search.slice(1) });
      setQueryData(data);
    }
  }, []);

  return (
    <div className="h-full bg-dark-d">
      <Outlet context={queryData} />
    </div>
  );
}
